import { OneLoginUser } from '../interfaces/OneLoginUser';
import secureLocalStorage from 'react-secure-storage';
import { StoredFields } from '../enums/StoredFields';

const useUser = () => {
  const user: OneLoginUser = Object(secureLocalStorage.getItem(StoredFields.ONE_LOGIN_USER));

  if (user) {
    return user;
  }

  return null;
}

export default useUser;
